import { render, staticRenderFns } from "./changelog.vue?vue&type=template&id=4b2cb993"
import script from "./changelog.vue?vue&type=script&lang=js"
export * from "./changelog.vue?vue&type=script&lang=js"
import style0 from "./changelog.vue?vue&type=style&index=0&id=4b2cb993&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports